module.exports = __webpack_public_path__ + "static/algolia.c962a407.svg";


//////////////////
// WEBPACK FOOTER
// ./src/algolia.svg
// module id = 249
// module chunks = 483